export function calculateScores(answerString, questionsList) {
  const scores = [
    { area: "Investigative", score: 0 },
    { area: "Social", score: 0 },
    { area: "Enterprising", score: 0 },
    { area: "Realistic", score: 0 },
    { area: "Conventional", score: 0 },
    { area: "Artistic", score: 0 },
  ];

  const scoreMap = scores.reduce((acc, obj) => {
    acc[obj.area] = obj;
    return acc;
  }, {});

  for (let i = 0; i < answerString.length; i++) {
    const question = questionsList[i];
    if (question) {
      const answerValue = parseInt(answerString[i], 10);
      if (!isNaN(answerValue)) {
        scoreMap[question.area].score += answerValue - 1;
      }
    }
  }

  return scores.sort((a, b) => b.score - a.score);
}
